import React from "react";
import { Container, Row } from "reactstrap";
import { NavLink } from "react-router-dom";

const PortfolioNav = () => {
  return (
    <Container fluid className="portfolio-section">
      <Row xs="4" className="inner-portfolio pb-3">
        <div>
          <NavLink className="py-2" to="/graphics">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 254.7 254.89">
              <title>pen</title>
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_3" data-name="Layer 3">
                  <path d="M250.57,106.38a14.13,14.13,0,0,0,0-20L168.29,4.14a14.11,14.11,0,0,0-20,0L118.41,34.05,220.66,136.29Z" />
                  <path d="M177.32,200l37.77-58.85L112.84,38.9,54.42,77.36a39.49,39.49,0,0,0-16.48,22.89L0,243.51l.54.54,71-71a10.8,10.8,0,1,1,10.11,10.11l-71,71,.73.73,142.85-38A39.5,39.5,0,0,0,177.32,200Z" />
                </g>
              </g>
            </svg>
          </NavLink>
        </div>
        <div>
          <NavLink className="py-2" to="/web">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280.54 279.08">
              <title>web-icon</title>
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_3" data-name="Layer 3">
                  <path d="M227.8,25.74H54.35A27,27,0,0,0,29.09,43.22a26.87,26.87,0,0,1,7.33-1H209.87a27,27,0,0,1,27,27V242.65a26.85,26.85,0,0,1-1.73,9.52,27,27,0,0,0,19.66-26V52.74A27,27,0,0,0,227.8,25.74Z" />
                  <path d="M253.54,0H80.09A27,27,0,0,0,54.83,17.48a26.87,26.87,0,0,1,7.33-1H235.61a27,27,0,0,1,27,27V216.91a26.85,26.85,0,0,1-1.73,9.52,27,27,0,0,0,19.66-26V27A27,27,0,0,0,253.54,0Z" />
                  <path d="M200.45,51.62H27a27,27,0,0,0-27,27V252.08a27,27,0,0,0,27,27H200.45a27,27,0,0,0,27-27V78.62A27,27,0,0,0,200.45,51.62ZM25.56,92.39A14.4,14.4,0,0,1,40,78H187.49a14.4,14.4,0,0,1,14.4,14.4V109H25.56Z" />
                </g>
              </g>
            </svg>
          </NavLink>
        </div>
        <div>
          <NavLink className="py-2" to="/coding">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 241.62 147.46">
              <title>Asset 16</title>
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_3" data-name="Layer 3">
                  <polygon points="42.53 73.73 74.39 41.87 53.12 20.61 0 73.73 0 73.73 0 73.73 53.12 126.85 74.39 105.59 42.53 73.73" />
                  <polygon points="241.62 73.73 241.62 73.73 188.5 20.61 167.24 41.87 199.09 73.73 167.24 105.59 188.5 126.85 241.62 73.73 241.62 73.73" />
                  <rect
                    x="44.36"
                    y="58.69"
                    width="152.91"
                    height="30.07"
                    transform="translate(-3.45 141.49) rotate(-60)"
                  />
                </g>
              </g>
            </svg>
          </NavLink>
        </div>
        <div>
          <NavLink className="py-2" to="/photography">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 273 254.09">
              <title>camara</title>
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_3" data-name="Layer 3">
                  <path d="M246,6.69H73.24V3.44A3.44,3.44,0,0,0,69.81,0H32.72a3.44,3.44,0,0,0-3.44,3.44V6.69H27a27,27,0,0,0-27,27v193.4a27,27,0,0,0,27,27H246a27,27,0,0,0,27-27V33.69A27,27,0,0,0,246,6.69ZM136.07,230.85a82.12,82.12,0,1,1,82.12-82.12A82.12,82.12,0,0,1,136.07,230.85ZM259.23,51.34a3.83,3.83,0,0,1-3.82,3.83H17.59a3.83,3.83,0,0,1-3.82-3.83V33.57a14.39,14.39,0,0,1,14.4-14.4H244.83a14.39,14.39,0,0,1,14.4,14.4Z" />
                  <path d="M136.07,80.66a68.07,68.07,0,1,0,68.08,68.07A68.08,68.08,0,0,0,136.07,80.66Zm0,130.78a62.71,62.71,0,1,1,62.71-62.71A62.71,62.71,0,0,1,136.07,211.44Z" />
                  <path d="M136.07,91.51a57.22,57.22,0,1,0,57.22,57.22A57.22,57.22,0,0,0,136.07,91.51ZM96.91,164l-.17.17a5.3,5.3,0,0,1-8.86-1.9,43.05,43.05,0,0,1-2.38-13.16,43.62,43.62,0,0,1,1.91-13.76,5.32,5.32,0,0,1,8.88-2.13l.17.18a5.34,5.34,0,0,1,1.27,5.29,32.1,32.1,0,0,0,.33,19.85A5.39,5.39,0,0,1,96.91,164Zm39.16,10.46a25.74,25.74,0,1,1,25.74-25.74A25.73,25.73,0,0,1,136.07,174.47Zm42.34-25.72h-.68A8.92,8.92,0,0,1,169,141.3a31.41,31.41,0,0,0-25.52-26,8.88,8.88,0,0,1,3.47-17.42,50,50,0,0,1,40.21,40.23A8.89,8.89,0,0,1,178.41,148.75Z" />
                </g>
              </g>
            </svg>
          </NavLink>
        </div>
      </Row>
    </Container>
  );
};

export default PortfolioNav;
